import { render, staticRenderFns } from "./FreeVideoItem.vue?vue&type=template&id=7d012cb8&scoped=true"
import script from "./FreeVideoItem.vue?vue&type=script&lang=js"
export * from "./FreeVideoItem.vue?vue&type=script&lang=js"
import style0 from "./FreeVideoItem.vue?vue&type=style&index=0&id=7d012cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d012cb8",
  null
  
)

export default component.exports